import { z } from 'zod';

import { UuidSchema } from './common.js';
import { PackageFacetsSchema, PublicPackageCardSchema } from './website-packages.js';

export const PublicDestinationPageSliderSchema = z.object({
  marketingTagId: UuidSchema,
  marketingTagName: z.string(),
  heading: z.string(),
  subheading: z.string().nullable(),
});
export const PublicDestinationPageFaqSchema = z.object({
  question: z.string(),
  answerHtml: z.string(),
});
export const PublicDestinationPageReelSchema = z.object({
  url: z.string(),
  thumbnailUrl: z.string().nullable(),
});
export const PublicDestinationPageSeoLinkSchema = z.object({
  groupLabel: z.string(),
  label: z.string(),
  href: z.string(),
});
export const PublicDestinationPageReviewSchema = z.object({
  customerName: z.string(),
  summary: z.string(),
  rating: z.number().int(),
  portraitUrl: z.string().nullable(),
  imageUrls: z.array(z.string()),
});

export const PublicDestinationPageSchema = z.object({
  slug: z.string(),
  destinationId: UuidSchema.nullable(),
  title: z.string(),
  heroHeading: z.string().nullable(),
  heroSubheading: z.string().nullable(),
  heroMediaUrl: z.string().nullable(),
  heroVideoUrl: z.string().nullable(),
  aboutHeading: z.string().nullable(),
  aboutHtml: z.string().nullable(),
  metaTitle: z.string().nullable(),
  metaDescription: z.string().nullable(),
  metaKeywords: z.string().nullable(),
  ogImageUrl: z.string().nullable(),
  sliders: z.array(PublicDestinationPageSliderSchema),
  faqs: z.array(PublicDestinationPageFaqSchema),
  reels: z.array(PublicDestinationPageReelSchema),
  seoLinks: z.array(PublicDestinationPageSeoLinkSchema),
  reviews: z.array(PublicDestinationPageReviewSchema),
});
export type PublicDestinationPage = z.infer<typeof PublicDestinationPageSchema>;

/** Slider carousel with prefetched package cards (aggregated public view). */
export const PublicDestinationSliderViewSchema = PublicDestinationPageSliderSchema.extend({
  items: z.array(PublicPackageCardSchema),
  total: z.number().int(),
});
export type PublicDestinationSliderView = z.infer<typeof PublicDestinationSliderViewSchema>;

export const PublicDestinationPageViewSchema = z.object({
  page: PublicDestinationPageSchema,
  facets: PackageFacetsSchema.nullable(),
  sliders: z.array(PublicDestinationSliderViewSchema),
});
export type PublicDestinationPageView = z.infer<typeof PublicDestinationPageViewSchema>;
